export default {
  "typesWithVersion": [
    "stop_registry_AccessibilityAssessment",
    "stop_registry_AccessibilityLimitations",
    "stop_registry_AddressablePlace",
    "stop_registry_Contact",
    "stop_registry_CycleStorageEquipment",
    "stop_registry_FareZone",
    "stop_registry_GeneralSign",
    "stop_registry_GroupOfStopPlaces",
    "stop_registry_GroupOfTariffZones",
    "stop_registry_HslAccessibilityProperties",
    "stop_registry_Organisation",
    "stop_registry_ParentStopPlace",
    "stop_registry_Parking",
    "stop_registry_PathLink",
    "stop_registry_PurposeOfGrouping",
    "stop_registry_Quay",
    "stop_registry_SanitaryEquipment",
    "stop_registry_ShelterEquipment",
    "stop_registry_StopPlace",
    "stop_registry_TariffZone",
    "stop_registry_TicketingEquipment",
    "stop_registry_TopographicPlace",
    "stop_registry_WaitingRoomEquipment",
    "stop_registry_infoSpot",
    "stop_registry_poster"
  ],
  "typesWithId": [
    "stop_registry_BoardingPosition",
    "stop_registry_PathLinkEnd",
    "stop_registry_PlaceEquipments"
  ],
  "embeddedTypes": [
    "stop_registry_AlternativeName",
    "stop_registry_EmbeddableMultilingualString",
    "stop_registry_EntityPermissions",
    "stop_registry_EntityRef",
    "stop_registry_GeoJSON",
    "stop_registry_KeyValues",
    "stop_registry_LocationRef",
    "stop_registry_ParkingArea",
    "stop_registry_ParkingCapacity",
    "stop_registry_ParkingProperties",
    "stop_registry_PrivateCode",
    "stop_registry_StopPlaceOrganisationRef",
    "stop_registry_Tag",
    "stop_registry_TransferDuration",
    "stop_registry_TransportModes",
    "stop_registry_UserPermissions",
    "stop_registry_ValidBetween",
    "stop_registry_VersionLessEntityRef",
    "stop_registry_externalLink",
    "stop_registry_stopPlaceExternalLink"
  ]
} as const;
